(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@price-point/http-helpers", [], factory);
	else if(typeof exports === 'object')
		exports["@price-point/http-helpers"] = factory();
	else
		root["@price-point/http-helpers"] = factory();
})(global, function() {
return 